var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',{attrs:{"type":"daterange","format":_vm.datePickerFormat,"align":"center","picker-options":_vm.pickerOptions},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})}
var staticRenderFns = []

export { render, staticRenderFns }